import {Model} from "ords/dist/model/model";

export class Image extends Model {
}

export const ImageModelConfig = {
    name: 'image',
    model: Image,
    relations: []
}
